module.exports = __webpack_public_path__ + "media/winner_full_house_3.fdd5de73.mp3";